import React, { useEffect, useState } from "react";
import DataTable from "../../../components/DataTable/DataTable";
// import DeleteIcon from "../../../assets/icons/deleteIcon.svg";
import { TableToolbar } from "../../../components/DataTable/DataTable.styles";
import ConfirmModal from "../../../components/ConfirmModal";
import { getFilteredTableData } from "../../../utils/Utils";
import { Select, MenuItem } from "@mui/material";

/* eslint-disable react/prop-types */
function SchemeDataTable({TableData, headCells,}) {
    const [confirmModal, setConfirmModal] = useState(false);
	const [dateFilter, setDateFilter] = useState("All");
	const [filteredData, setFilteredData] = useState([]);

    useEffect(() => {
		handleDateFilterChange({ target: { value: dateFilter } });
	}, [TableData]);
    

    const handleDateFilterChange = (e) => {
		// Filter TableData based on date - All Time, Today, Last 7 days, Last 30 days, Last 6 months, Last 12 months
		let filteredTableData = getFilteredTableData(e.target.value, TableData);
		setDateFilter(e.target.value);
		setFilteredData(filteredTableData);
	};

    const handleDeleteAction = () => {
		// console.log("selected", selectedItems);
		// setConfirmModal(false);
		// handleDeleteScheme(selectedItems);
	};

    const SchemeTableToolbar = () => {
		return (
			<TableToolbar>
				{/* <div className='_notification'>3 new completed deal</div> */}
				<div className='_notification'>{filteredData.length} Item(s) Found</div>

				<div className='_buttons'>
					

					<Select value={dateFilter} className='toolbarSelect' onChange={(e) => handleDateFilterChange(e)}>
						<MenuItem value='Today'>Today</MenuItem>
						<MenuItem value='Week'>Last 7 days</MenuItem>
						<MenuItem value='Month'>Last 30 days</MenuItem>
						<MenuItem value='6 Months'>Last 6 months</MenuItem>
						<MenuItem value='Year'>Last 12 months</MenuItem>
						<MenuItem value='All'>All Time</MenuItem>
					</Select>

					
						{/* <TableButton
							variant='outlined'
							color='error'
							onClick={() => {
								setSelectedItems(selected);
								setConfirmModal(true);
							}}>
							<img src={DeleteIcon} alt='' />
						</TableButton> */}
					

					{/* <TableButton variant='outlined' color='primary'>
						<img src={ExportIcon} alt='' />
					</TableButton> */}
				</div>
			</TableToolbar>
		);
	};

  return (
    <>
			<DataTable TableData={filteredData} headCells={headCells} TableToolbar={SchemeTableToolbar} />
			{confirmModal && (
				<ConfirmModal
					confirmModal={confirmModal}
					setConfirmModal={setConfirmModal}
					content={{
						title: "Delete Apprenticeship Finance",
						desc: "Are you sure you want to delete this AF object(s)?",
						btnText: "Yes, Delete",
					}}
					handleDeleteAction={handleDeleteAction}
				/>
			)}
		</>
  )
}

export default SchemeDataTable